import * as React from 'react'
import { Text as StyledText } from '@chakra-ui/core'
import { BoxProps } from '../box'
import { textStyles } from '../../base/typography'

interface TextProps extends BoxProps {
	variant?: 'largeHero' | 'hero' | 'headline' | 'subheadline' | 'title1' | 'title2' | 'title3'
		| 'body' | 'callout' | 'caption1' | 'caption2' | 'footnote' | 'label' | 'value'
}

const Text: React.FC<TextProps> = (props: any): React.ReactElement => {
	const {
		variant,
		...rest
	} = props

	let textProps: any = {}
	if (variant && textStyles[variant]) {
		textProps = textStyles[variant]
	}

	return <StyledText m={0} {...textProps} {...rest} />
}

Text.defaultProps = {
	variant: 'body'
}

export { TextProps }

export default Text
